import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export const useFocusOnRender = (ref: React.RefObject<HTMLInputElement>, field: string) => {
  const { editModalFocusField } = useSelector((state: any) => state.mySales);

  useEffect(() => {
    if (ref.current && editModalFocusField === field) {
      ref.current.focus();
    }
  }, [field]);
};
